import "core-js/stable";
import "simplebar/src/simplebar.css";
import React from "react";
import { createRoot } from "react-dom/client";
import ErrorBoundary from "./playcreator/components/ErrorBoundary.js";
import { SnackbarProvider } from "notistack";
import ThemeProvider from "./wp_theme";
import "./playviewer/css/additional.css";
import "./playcreator/css/quill.snow.css";
import ViewerPlay from "./playviewer/components/ViewerPlay";
import PlaybookViewer from "./playviewer/components/PlaybookViewer";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import { persistStore, persistReducer, createMigrate } from "redux-persist";
import { configureStore } from "@reduxjs/toolkit";
import logger from "redux-logger";
import printSettings from "./redux/slices/printSettings";
import { Provider as ReduxProvider } from "react-redux";
import WebFont from "webfontloader";
import Helper from "./playcreator/functions/Helper.js";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { renderToString } from "react-dom/server";

var urlParams = new URLSearchParams(window.location.search);
const playbookCode = urlParams.get("playbook");
const playCode = urlParams.get("code");
const rootElement = document.getElementById("viewer-app");
const cache = createCache({ key: "css", prepend: false });

const printSettingsPersistConfig = {
  key: "printSettings",
  storage,
  version: Helper.printSettingsModelVersion,
  migrate: createMigrate(Helper.printSettingsMigrations, { debug: true }),
};
const rootReducer = combineReducers({
  printSettings: persistReducer(printSettingsPersistConfig, printSettings),
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }).concat(logger),
});

persistStore(store);
const root = createRoot(rootElement);

if (playCode) {
  let play = window.__INITIAL_DATA__;

  root.render(
    <ErrorBoundary environment={"playviewer"}>
      <ReduxProvider store={store}>
        <SnackbarProvider>
          <CacheProvider value={cache}>
            <ThemeProvider>
              <ViewerPlay play={play} />
            </ThemeProvider>
          </CacheProvider>
        </SnackbarProvider>
      </ReduxProvider>
    </ErrorBoundary>
  );
} else if (playbookCode) {
  let playbook = window.__INITIAL_DATA__;
  root.render(
    <ErrorBoundary environment={"playviewer"}>
      <ReduxProvider store={store}>
        <SnackbarProvider>
          <CacheProvider value={cache}>
            <ThemeProvider>
              <PlaybookViewer playbook={playbook} />
            </ThemeProvider>
          </CacheProvider>
        </SnackbarProvider>
      </ReduxProvider>
    </ErrorBoundary>
  );
} else {
  root.render(<div>There was an error. Make sure the link is correct</div>);
}

WebFont.load({
  google: {
    families: [
      "Roboto:400,600,700",
      "Public Sans:400,600,700",
      "Barlow:400,600,700,800",
      "Poppins:400,600,700",
    ],
  },
});
